"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcologyExperts = void 0;
const Tags_1 = require("../Tags");
const CardName_1 = require("../../CardName");
const PreludeCard_1 = require("./PreludeCard");
const Resources_1 = require("../../Resources");
const PlayProjectCard_1 = require("../../deferredActions/PlayProjectCard");
const CardRenderer_1 = require("../render/CardRenderer");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class EcologyExperts extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ECOLOGY_EXPERTS,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.MICROBE],
            metadata: {
                cardNumber: 'P10',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.plants(1)).br.br;
                    b.projectRequirements();
                }),
                description: 'Increase your plant production 1 step. Play a card from hand, ignoring global requirements.',
            },
        });
        this.requirementsBonus = 50;
    }
    getRequirementBonus(player) {
        if (player.lastCardPlayed !== undefined && player.lastCardPlayed.name === this.name) {
            return this.requirementsBonus;
        }
        return 0;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        let copiedByDoubleDown = false;
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (player.lastCardPlayed !== undefined && player.lastCardPlayed.name === CardName_1.CardName.DOUBLE_DOWN) {
                copiedByDoubleDown = true;
                player.requirementsBonus += this.requirementsBonus;
            }
            return undefined;
        }));
        let copiedByEunice = false;
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            const eunice = player.playedCards.find((card) => card.name === CardName_1.CardName.EUNICE);
            if (eunice !== undefined && eunice.opgActionIsActive === true) {
                copiedByEunice = true;
                player.requirementsBonus += this.requirementsBonus;
            }
            return undefined;
        }));
        player.game.defer(new PlayProjectCard_1.PlayProjectCard(player));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (copiedByDoubleDown)
                player.requirementsBonus -= this.requirementsBonus;
            return undefined;
        }));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (copiedByEunice)
                player.requirementsBonus -= this.requirementsBonus;
            return undefined;
        }));
        return undefined;
    }
}
exports.EcologyExperts = EcologyExperts;
//# sourceMappingURL=EcologyExperts.js.map